var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: { "label-width": "200px" },
              model: {
                value: _vm.pram,
                callback: function ($$v) {
                  _vm.pram = $$v
                },
                expression: "pram",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                _vm._l(_vm.tableData.data, function (item, index) {
                  return _c(
                    "el-col",
                    { key: index, attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.setName(item.key),
                            prop: "remark",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row upLoadPicBox row-middle" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "upload-demo",
                                  attrs: {
                                    action: "",
                                    "http-request": _vm.handleUploadForm,
                                    data: { index: index },
                                    headers: _vm.myHeaders,
                                    "show-file-list": false,
                                  },
                                },
                                [
                                  item.value
                                    ? _c("div", { staticClass: "pictrue" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.setUrl(item.value),
                                          },
                                        }),
                                      ])
                                    : _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "upload-warning" }, [
                                _vm._v(
                                  " \n                  " +
                                    _vm._s(_vm.$t("sctpWarning")) +
                                    "\n                "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["roleManager:imageSetting:save"],
                      expression: "['roleManager:imageSetting:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("trueText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }